// extracted by mini-css-extract-plugin
module.exports = {"giftCardIcon":"GitftCardLink_giftCardIcon__V51KV","leftToRight":"GitftCardLink_leftToRight__Nj167"};